import { render, staticRenderFns } from "./removeShare.vue?vue&type=template&id=45d31742&"
import script from "./removeShare.vue?vue&type=script&lang=js&"
export * from "./removeShare.vue?vue&type=script&lang=js&"
import style0 from "./removeShare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports